// extracted by mini-css-extract-plugin
export default {"card":"cards_card"};